export default __webpack_public_path__ + "static/media/playerbiotheme.50de6833.png";